module.exports = __webpack_public_path__ + "img/vertical-phone.e88e4a02.svg";